import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const get = async (url, config = {}) => {
  try {
    const response = await api.get(url, config);
    const { status, data } = response;

    if (status !== 200) {
      console.log(response);
      throw new Error("get request has failed");
    }

    return data;
  } catch (err) {
    if (err?.name === "AxiosError") {
      if (err?.response?.data) {
        return err?.response?.data;
      }
    }

    throw err;
  }
};

export const post = async (url, body = {}, config = {}) => {
  try {
    const response = await api.post(url, body, config);
    const { status, data } = response;

    if (status !== 200 && status !== 201) {
      console.log(response);
      throw new Error("post request has failed");
    }

    return data;
  } catch (err) {
    if (err?.name === "AxiosError") {
      if (err?.response?.data) {
        return err?.response?.data;
      }
    }

    throw err;
  }
};
